module.exports = __webpack_public_path__ + "static/media/7.984c8e79.png";